import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appGenericContentDirective]'
})
export class GenericContentDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
